export const environment = {
  production: false,
  oktaConfig: {
    clientId: '0oa2gp4lzmtypQFR00h8',
    issuer: 'https://myappstest.halliburton.com/oauth2/aus2g5leuppRFvSWO0h8',
    redirectUri: 'https://dev.adr.ienergy.halliburton.com/login/callback',
    postLogoutRedirectUri: 'https://dev.adr.ienergy.halliburton.com/',
    scopes: ['address', 'email', 'offline_access', 'openid', 'phone', 'profile'],
    pkce: true,
    testing: {
      disableHttpsCheck: true,
    },
  },
  // Microsoft Entra ID configuration for the deployed Dev environment.
  // Replace the placeholder values with your Azure AD app registration details.
  msalConfig: {
    auth: {
      clientId: 'ca31ba1b-9699-4e01-9575-684f01bc164c',
      authority: 'https://login.microsoftonline.com/b7be7686-6f97-4db7-9081-a23cf09a96b5',
      redirectUri: 'https://dev.adr.ienergy.halliburton.com/login/callback',
      postLogoutRedirectUri: 'https://dev.adr.ienergy.halliburton.com/',
    },
    cache: {
      cacheLocation: 'sessionStorage' as const,
      storeAuthStateInCookie: false,
    },
  },
  // Scope URI for the backend API registered in Azure AD
  msalScopeUri: 'api://ca31ba1b-9699-4e01-9575-684f01bc164c/Simulation.All',
};
